import api from './utilBackoffice';

const controller = 'OrigemRecurso';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  Update: (id, dto) => {
    return api.Axios.Put(url, id, dto);
  }
});
